export const ITEM_CATEGORY_COLUMNS = [
  {
    Header: "Item Category Code",
    accessor: "ItemCatgCd"
  },
  {
    Header: "Description",
    accessor: "Description"
  },
  {
    Header: "Category Type",
    accessor: "CategoryType.CodeDescription"
  },
  {
    Header: "Inspection Code",
    accessor: "InspectionCode.CodeDescription"
  },
  {
    Header: "Active",
    accessor: "Active",
    Cell: ({ cell }) => (cell.value ? "Yes" : "No")
  }
];

export const ITEM_USAGE_COLUMNS = [
  {
    Header: "First Name",
    accessor: "FirstName",
    id: "FirstName"
  },
  {
    Header: "Last Name",
    accessor: "LastName",
    id: "LastName"
  },
  {
    Header: "Job Title",
    accessor: "JobTitle",
    id: "JobTitle"
  },
  {
    Header: "Phone #",
    accessor: "BusinessPhone",
    id: "BusinessPhone"
  },
  {
    Header: "Mobile #",
    accessor: "MobilePhone",
    id: "MobilePhone"
  },
  {
    Header: "Fax #",
    accessor: "FaxNo",
    id: "FaxNo"
  },
  {
    Header: "Email",
    accessor: "EmailAddress",
    id: "EmailAddress"
  },
  {
    Header: "Active",
    accessor: "Active",
    id: "Active"
  }
];
